import { redirectToLogin, handleLogout } from './authHelper';

export const unAuthorizedToken = () => {
    // Redirect to Bifrost login on unauthorized access
    redirectToLogin();
}

export const emailValidation = (email) =>{
    let myregex = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
    return !myregex.test(email) ? {
            status: false,
            message: 'Email is not valid'
        } :
        {
            status: true,
            message: 'Successful'
        }
}

export const textEmptyValidation = (text) =>{
    if (text === undefined || text === null || text === '' || text.trim().length === 0){
        return {
            status: false,
            message: 'Invalid Entry'
        }
    } else{
        return {
            status: true,
            message: 'Successful'
        }
    }
}
export const phoneNumberValidation = (phoneNumber) =>{
    let myregex = /^\d{0,10}$/;
    return !myregex.test(phoneNumber) ? {
            status: false,
            message: 'Phone Number is not valid'
        } :
        {
            status: true,
            message: 'Successful'
        }
}


// WEBPACK FOOTER //
// ./src/utils/Validations.js